module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "person-card"
  }, [_c('a', {
    staticClass: "close-button",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), (_vm.attendee.pictureUrl) ? _c('img', {
    staticClass: "card-image",
    attrs: {
      "src": _vm.attendee.pictureUrl,
      "onerror": "this.onerror = \"null\"; this.src = \"/static/img/anonymous.svg\""
    }
  }) : _c('img', {
    staticClass: "card-image",
    attrs: {
      "src": require("../assets/icons/anonymous.svg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.attendee.firstName) + " " + _vm._s(_vm.attendee.lastName))]), _vm._v(" "), _c('div', {
    staticClass: "bottom-content"
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.attendee.headline))]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.attendee.location))]), _vm._v(" "), _c('div', {
    staticClass: "social-icons"
  }, [_vm._l((this.attendee.social), function(network, index) {
    return _c('div', {
      key: index,
      staticClass: "inline-list"
    }, [_c('socialIcons', {
      attrs: {
        "attendee": _vm.attendee,
        "network": network
      }
    })], 1)
  }), _vm._v(" "), (_vm.attendee.id !== _vm.user.id) ? _c('a', {
    staticClass: "chat-icon",
    on: {
      "click": function($event) {
        _vm.openChat(_vm.attendee)
      }
    }
  }, [_c('img', {
    staticClass: "dl-logo",
    attrs: {
      "src": require("../assets/icons/person_card_chat_icon.svg")
    }
  })]) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ac07326","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PersonCard.vue
// module id = 462
// module chunks = 0